import { useState, useEffect } from "react";
import { Divider, Group, TextInput, Button } from "@mantine/core";
import { Card, message, Flex, Spin } from "antd";
import { useAuthContext } from "../../Hooks/UseAuthContext";










const Bankdetailsform = ({ rectification = false, stepData, submissionDetails, onSuccess }) => {
    const { user } = useAuthContext();
    const [submitloading, setSubmitloading] = useState(false);
    const [companyProfile, setCompanyProfile] = useState(null);
    const [compliancedetails, setCompliancedetails] = useState(null);
    const [banks, setBanks] = useState([
        {
            bank_name: "",
            account_number: "",
            ifsc_code: "",
            bank_branch: "",
        },
    ]);
    const handleChange = (index, field, value) => {
        const updated = [...banks];
        updated[index][field] = value;
        setBanks(updated);
    };
    const addBanks = () => {
        setBanks([
            ...banks,
            {
                bank_name: "",
                account_number: "",
                ifsc_code: "",
                bank_branch: "",
            },
        ]);
    };
    const removeBanks = (index) => {
        const updated = banks.filter((_, i) => i !== index);

        // Edge case: ensure at least 1 director always exists
        if (updated.length === 0) {
            updated.push({
                bank_name: "",
                account_number: "",
                ifsc_code: "",
                bank_branch: "",
            });
        }

        setBanks(updated);
    };
    const getUserData = async () => { // for get the updated user data after company profile submission
        await fetch('https://api.boompay.in/get-user', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`,
            }
        });
        // const data = await response.json();
        // if (response.status === 200) {
        //     // console.log(data.user);
        //     setUserprofile(data.user);
        //     setActive(data.user.Completed_step);
        //     setLoading(false);
        // } else if (response.status === 401) {
        //     setLoading(false);
        //     console.log('Unauthorized access. Please log in again.');
        //     message.error('Unauthorized access. Please log in again.');
        // } else if (response.status === 404) {
        //     setLoading(false);
        //     console.log('User not found.');
        //     message.error('User not found.');
        // } else {
        //     setLoading(false);
        //     console.log('An error occurred while fetching user data.');
        //     message.error('An error occurred while fetching user data.');
        // }
    }
    const handelSubmit = async () => {
        if (banks.some(bank => !bank.bank_name || !bank.account_number || !bank.ifsc_code || !bank.bank_branch)) {
            message.error('Please fill in all bank details before submitting.');
            return;
        }
        setSubmitloading(true);
        try {
            const response = await fetch('https://api.boompay.in/submit-bank-details', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    Banks: banks,
                    Company_profile_id: companyProfile._id,
                    Compliance_and_MAF_id: compliancedetails._id,
                    Completed_step: 3, // Update the Completed_step to 3 after submitting Banks details
                }),
            });
            const data = await response.json();
            if (response.status === 201) {
                //console.log(data.message);
                getUserData();
                setBanks([
                    {
                        bank_name: "",
                        account_number: "",
                        ifsc_code: "",
                        bank_branch: "",
                    },
                ])
                setSubmitloading(false);
                message.success(data.message);
            } else if (response.status === 401) {
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
                setSubmitloading(false);
            } else {
                console.log('An error occurred while submitting bank details.');
                message.error('An error occurred while submitting bank details.');
                setSubmitloading(false);
            }
        } catch (error) {
            console.error('Error:', error);
            message.error('An unexpected error occurred. Please try again later.');
            setSubmitloading(false);
        }
    }
    const handleRectificationSubmit = async () => {
        if (banks.some(bank => !bank.bank_name || !bank.account_number || !bank.ifsc_code || !bank.bank_branch)) {
            message.error('Please fill in all bank details before submitting.');
            return;
        }
        setSubmitloading(true);
        try {
            const response = await fetch('https://api.boompay.in/put/rectify/bank-details', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    Banks: banks,
                    Company_profile_schema_id: submissionDetails?.Company_profile_schema_id
                })
            });
            const data = await response.json();
            if (response.status === 201) {
                //console.log(data.message);
                message.success(data?.message)
                onSuccess(); // Refresh user data to update.
                setSubmitloading(false);
            } else if (response.status === 400) {
                message.error(data.message);
                console.log(data.message);
            } else if (response.status === 401) {
                message.error('Unauthorized access. Please log in again.');
                console.log('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                message.error('User not found.');
                console.log('User not found.');
            } else {
                message.error('An error occurred while submitting company profile.');
                console.log('An error occurred while submitting company profile.');
            }
        } catch (error) {
            message.error('An error occurred while submitting company profile.');
            console.error('Error:', error);
        }
        setSubmitloading(false);
    }
    useEffect(() => {
        const getCompanyProfile = async () => {
            const response = await fetch('https://api.boompay.in/get-company-profile', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                //console.log(data.Companyprofile);
                setCompanyProfile(data.Companyprofile);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Company profile not found.');
                message.error('Company profile not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getComplianceandmaf = async () => {
            const response = await fetch('https://api.boompay.in/get-compliance-details-and-maf', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                //console.log(data.Complianceandmafdetails);
                setCompliancedetails(data.Complianceandmafdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Compliance details not found.');
                message.error('Compliance details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }

        if (user) {
            getCompanyProfile();
            getComplianceandmaf();
        }
    }, [user])

    useEffect(() => {
        const getUserData = async () => {
            setSubmitloading(true);
            const response = await fetch('https://api.boompay.in/get-submitted-details-for-rectification', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            //console.log(data);

            if (response.status === 200) {
                const profile = data.RectificationDetails.Bank_details_schema_id;
                // Bank Details
                setBanks(profile.Banks || []);
                setSubmitloading(false);
            } else if (response.status === 401) {
                setSubmitloading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                setSubmitloading(false);
                console.log('User not found.');
                message.error('User not found.');
            } else {
                setSubmitloading(false);
                console.log('An error occurred while fetching user data.');
                message.error('An error occurred while fetching user data.');
            }
        }

        if (user && rectification) {
            getUserData();
        }
    }, [user, rectification])
    return (
        <>
            <Flex gap="medium" vertical>
                <Spin spinning={submitloading} size="large" description="Please wait...">
                    <Card title="Bank details" style={{ "box-shadow": "rgba(0, 0, 0, 0.24) 0px 3px 8px", }}>
                        <Group>
                            <TextInput label="Company name" value={companyProfile?.Company_name || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company CIN number" value={companyProfile?.Company_CIN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company PAN number" value={companyProfile?.Company_PAN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="GST number" value={companyProfile?.Company_GST_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="MSME number" value={companyProfile?.Company_MSME_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company address" value={companyProfile?.Company_address || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company mobile number" value={companyProfile?.Company_Mobile_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company email id" value={companyProfile?.Company_email || ""} disabled radius="xs" size="md" />
                        </Group>
                        <Divider label="Whiteliste bank details" my="sm" variant="dashed" labelPosition="center" />
                        {banks.map((bank, index) => (
                            <Group key={index} mt={'lg'}>
                                <TextInput
                                    label="Bank name"
                                    value={bank.bank_name}
                                    onChange={(e) => handleChange(index, "bank_name", e.target.value)}
                                    required

                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="Account number"
                                    value={bank.account_number}
                                    onChange={(e) => handleChange(index, "account_number", e.target.value)}
                                    required

                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="IFSC code"
                                    value={bank.ifsc_code}
                                    onChange={(e) => handleChange(index, "ifsc_code", e.target.value)}
                                    required

                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="Branch"
                                    value={bank.bank_branch}
                                    onChange={(e) => handleChange(index, "bank_branch", e.target.value)}
                                    required

                                    radius="xs"
                                    size="md"
                                />

                                <Button mt="xs" onClick={addBanks} size="xs" variant="light">
                                    + Add Bank
                                </Button>
                                {banks.length > 1 && (
                                    <Button
                                        mt="xs"
                                        color="red"
                                        variant="light"
                                        onClick={() => removeBanks(index)}
                                        size="xs"
                                    >
                                        - Remove Bank
                                    </Button>
                                )}
                            </Group>
                        ))}
                        <Group justify="end">
                            {/* <Button mt={'md'} size="lg" color="lime" variant="light" onClick={handelSubmit} loading={submitloading}>Save changes</Button> */}
                            <Button
                                mt={'md'}
                                size="lg"
                                color="lime"
                                variant="light"
                                loading={submitloading}
                                onClick={
                                    rectification
                                        ? handleRectificationSubmit
                                        : handelSubmit
                                }
                            >
                                {
                                    rectification
                                        ? "Submit Rectification"
                                        : "Save Changes"
                                }
                            </Button>
                        </Group>

                    </Card>
                </Spin>
            </Flex>

        </>
    )
}
export default Bankdetailsform